import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { SearchCategory } from '@backrs_ui/grow-ui/src/pages/Search/search.types';

import { Box, SxProps, Theme } from '@mui/material';

import { FilterDropdown } from './Filter/FilterDropdown';
import { SingleFilterButton } from './SingleFilterButton';
import { SearchParentCategory } from '../search.types';

const SEARCH_STRINGS = appStrings.modules.search;

type SearchFiltersGroupProps = Readonly<{
  selectedItems?: SearchCategory[];
  setSelectedItems: (category: SearchCategory[]) => void;
  categories: SearchParentCategory[];
}>;

export const SearchFiltersGroup = ({
  selectedItems,
  setSelectedItems,
  categories,
}: SearchFiltersGroupProps) => {
  const areThereAnyMoreFilters = categories.some((category) => category.isInMoreFilters);

  return (
    <Box sx={searchFilterContainerStyle}>
      <Box sx={filterGroupStyle}>
        {categories.map((category) => {
          if (category.isInMoreFilters) {
            return null;
          }

          // if the category is not in the more filters dropdown and has only one sub category, show a single filter button that is styled like the filter dropdown
          if (category.categories.length === 1) {
            const subCategory = category.categories[0].key;

            const isSelected = (selectedItems || []).includes(subCategory);

            return (
              <SingleFilterButton
                key={category.name}
                name={category.name}
                iconName={category.iconName}
                isSelected={isSelected}
                toggleFilter={() => {
                  if (isSelected) {
                    setSelectedItems((selectedItems || []).filter((item) => item !== subCategory));

                    return;
                  }

                  setSelectedItems([...(selectedItems || []), subCategory]);
                }}
              />
            );
          }

          // if the category is not in the more filters dropdown, show the filter dropdown
          return (
            <FilterDropdown
              key={category.name}
              name={category.name}
              iconName={category.iconName}
              selectedItems={selectedItems}
              onSelect={setSelectedItems}
              hasSelectedItems={category.categories.some((category) =>
                (selectedItems || []).includes(category.key),
              )}
              menuItems={category.categories}
            />
          );
        })}
      </Box>
      {areThereAnyMoreFilters && (
        <Box>
          {/* if the category is in the more filters dropdown, show the more filters dropdown */}
          <FilterDropdown
            selectedItems={selectedItems}
            onSelect={setSelectedItems}
            iconName="FilterLines"
            name={SEARCH_STRINGS.moreFilters}
            hasSelectedItems={categories
              .filter((category) => category.isInMoreFilters)
              .some((category) =>
                category.categories.some((subCategory) =>
                  (selectedItems || []).includes(subCategory.key),
                ),
              )}
            menuItems={categories
              .filter((category) => category.isInMoreFilters)
              .flatMap((category) => category.categories)}
          />
        </Box>
      )}
    </Box>
  );
};

const searchFilterContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
  flexWrap: 'wrap',
  rowGap: backrs.spacing['spacing-xl'],
});

const filterGroupStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: backrs.spacing['spacing-xl'],
  flexWrap: 'wrap',
});
